module.exports = __webpack_public_path__ + "img/canvas.2d29b005.png";